import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	InputGroup, FormControl, Button, FormGroup,
} from 'react-bootstrap';
import {
	isEqual, isEmpty, filter, get,
} from 'lodash';
import { Loader } from '@components/common';
import EmptyState from '../components/emptyState';
import Officer from '../components/officer';

const filterOfficers = (value, officers) => (
	filter(officers, ({ OfficerProfile, OfficerName }) => {
		const name = OfficerProfile ? `${OfficerProfile.FirstName} ${OfficerProfile.LastName}` : OfficerName;
		return (name.toLowerCase().includes(value.toLowerCase()));
	})
);

class AssignedOfficers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value               : '',
			assignedOfficers    : props.assignedOfficers,
			rawAssignedOfficers : props.assignedOfficers,
		};
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		const newState = {};

		let { assignedOfficers } = nextProps;

		if (!isEmpty(lastState.value)) assignedOfficers = filterOfficers(lastState.value, nextProps.assignedOfficers);

		if (!isEqual(nextProps.assignedOfficers, lastState.rawAssignedOfficers)) newState.rawAssignedOfficers = nextProps.assignedOfficers;

		if (!isEqual(assignedOfficers, lastState.assignedOfficers)) newState.assignedOfficers = assignedOfficers;

		return !isEmpty(newState) ? newState : null;
	}

	shouldComponentUpdate = ({
		isLoading,
		timeZone,
		positionId,
		allowAssign,
		allowUnassign,
		isActiveOrCompletedJob,
	}, {
		value,
		assignedOfficers,
	}) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(isLoading, lastProps.isLoading)
			|| !isEqual(timeZone, lastProps.timeZone)
			|| !isEqual(positionId, lastProps.positionId)
			|| !isEqual(allowAssign, lastProps.allowAssign)
			|| !isEqual(allowUnassign, lastProps.allowUnassign)
			|| !isEqual(isActiveOrCompletedJob, lastProps.isActiveOrCompletedJob)
			|| !isEqual(assignedOfficers, lastState.assignedOfficers)
			|| !isEqual(value, lastState.value)
		);
	}

	onFieldChange = ({ target : { value } }) => this.setState({ value }, this.onSearch)

	onKeyPress = ({ key }) => {
		// Execute search onPress Enter
		if (key === 'Enter') this.onSearch();
	}

	onSearch = () => {
		const { value } = this.state;
		const {
			assignedOfficers : rawAssignedOfficers,
		} = this.props;

		let assignedOfficers = rawAssignedOfficers;

		if (!isEmpty(value)) assignedOfficers = filterOfficers(value, rawAssignedOfficers);

		this.setState({ assignedOfficers });
	}

	onClickDetails = (userId) => () => {
		const {
			positionId,
			onClickDetails,
		} = this.props;

		onClickDetails({ positionId, userId });
	}

	getOfficerData = (officer, property) => get(officer, property, '')

	getFullName = (officer) => (
		officer.isExternal
			? this.getOfficerData(officer, 'OfficerName')
			: `${this.getOfficerData(officer, 'OfficerProfile.FirstName')} ${this.getOfficerData(officer, 'OfficerProfile.LastName')}`
	)

	render() {
		const {
			isLoading,
			timeZone,
			positionId,
			isActiveOrCompletedJob,
			fromModal,
		} = this.props;

		const {
			value,
			assignedOfficers,
		} = this.state;

		return (
			<React.Fragment>
				<If condition={(!isEmpty(assignedOfficers) || value) && !fromModal}>
					<div className="applicant-search">
						<FormGroup>
							<InputGroup className="input-group--darker">
								<FormControl
									value={value}
									name="applicant-search"
									placeholder="Search by name"
									onChange={this.onFieldChange}
									onKeyPress={this.onKeyPress}
								/>
								<InputGroup.Button>
									<Button onClick={this.onSearch}>
										<i className="rkf rkf-search" />
									</Button>
								</InputGroup.Button>
							</InputGroup>
						</FormGroup>
					</div>
				</If>
				<div className="scroll__officers__container">
					<div className="scroll__officers">
						<For
							index="index"
							each="officer"
							of={assignedOfficers}
						>
							<Officer
								key={`assigned_officer_${index}`}
								timeZone={timeZone}
								url={this.getOfficerData(officer, 'OfficerProfile.ContactPhotoUrl')}
								firstName={
									officer.isExternal
										? this.getOfficerData(officer, 'OfficerName')
										: this.getOfficerData(officer, 'OfficerProfile.FirstName')
								}
								lastName={this.getOfficerData(officer, 'OfficerProfile.LastName')}
								phone={this.getOfficerData(officer, 'OfficerProfile.CellPhone')}
								email={this.getOfficerData(officer, 'OfficerProfile.Email')}
								createDate={this.getOfficerData(officer, 'CreateDateUTC')}
								officerRank={this.getOfficerData(officer, 'OfficerProfile.OfficerRank')}
								jurisdiction={this.getOfficerData(officer, 'OfficerProfile.JurisdictionName')}
								jobsWorked={this.getOfficerData(officer, 'TotalJobsWorked')}
								upcomingJobs={this.getOfficerData(officer, 'OfficerProfile.UpcomingJobsScheduled')}
								totalHours={this.getOfficerData(officer, isActiveOrCompletedJob ? 'WorkedHours' : 'OfficerProfile.TotalWorkedHours')}
								clockIn={this.getOfficerData(officer, 'ClockIn')}
								clockOut={this.getOfficerData(officer, 'ClockOut')}
								officerStatusType={this.getOfficerData(officer, 'OfficerStatus')}
								isRKPay={this.getOfficerData(officer, 'OfficerProfile.IsRKPay')}
								isPermanent={this.getOfficerData(officer, 'RecurrenceRuleJobAssignment')}
								isExternal={officer.isExternal}
								isActiveOrCompletedJob={isActiveOrCompletedJob}
							/>
						</For>
					</div>
					<If condition={isEmpty(assignedOfficers)}>
						<EmptyState
							message={isEmpty(value) ? 'No Officers Assigned' : 'No officers found'}
							positionId={positionId}
						/>
					</If>
					<Loader
						size="small"
						active={isLoading}
					/>
				</div>
			</React.Fragment>
		);
	}
}

AssignedOfficers.propTypes = {
	allowAssign            : PropTypes.bool,
	allowUnassign          : PropTypes.bool,
	assignedOfficers       : PropTypes.array,
	fromModal              : PropTypes.bool,
	isActiveOrCompletedJob : PropTypes.bool,
	isLoading              : PropTypes.bool,
	onClickDetails         : PropTypes.func.isRequired,
	positionId             : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	timeZone : PropTypes.string,
};

AssignedOfficers.defaultProps = {
	allowAssign            : false,
	allowUnassign          : true,
	assignedOfficers       : [],
	fromModal              : false,
	isActiveOrCompletedJob : false,
	isLoading              : false,
	positionId             : '',
	timeZone               : '',
};

export default AssignedOfficers;
